import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import RegistrationModalArt from 'assets/images/registrationModalArt.jpg';
import { useLazyGetRegistrationFreeSlotsQuery } from 'redux/apiSlice/events.slice';
import { Image } from '../../../../../Base/Image';
import useRegistrationContext, {
  AgeGroupCapacitiesType,
} from '../../context/NewRegistrationModalContext';
import ChooseLanguage from '../ChooseLanguage';
import EventInformation from '../../steps/EventInformation';
import AdultInformation from '../../steps/AdultInformation';
import {
  LeftRegistrationContentWrapper,
  RegistrationContentBody,
  RightRegistrationContentWrapper,
} from './RegistationContent.style';
import {
  TRegistrationFormDataUI,
  TRegistrationFormDataDB,
  TClassesByAgeGroupUI,
} from '../../../../../../data/types/events.types';
import ProvidingChildCare from '../../steps/ProvidingChildCare';

const RegistrationContent = ({
  eventDetailsData,
}: {
  eventDetailsData?: TRegistrationFormDataUI | TRegistrationFormDataDB;
}) => {
  const {
    stepper,
    eventDetails,
    setEventDetails,
    setEnglishGroupCapacities,
    setSpanishGroupCapacities,
  } = useRegistrationContext();
  const [getFreeSlots] = useLazyGetRegistrationFreeSlotsQuery();

  // Sets initial details of event when modal opens
  useEffect(() => {
    if (isEmpty(eventDetails)) {
      setEventDetails(eventDetailsData);
    }

    if (!isEmpty(eventDetailsData)) {
      const englishClasses: TClassesByAgeGroupUI[] = [
        ...(eventDetailsData?.englishClasses as TClassesByAgeGroupUI[]),
      ];
      const spanishClasses: TClassesByAgeGroupUI[] = [
        ...(eventDetailsData?.spanishClasses as TClassesByAgeGroupUI[]),
      ];
      const allClasses: TClassesByAgeGroupUI[] = [
        ...englishClasses,
        ...spanishClasses,
      ];

      const fetchData = async () => {
        const results = await Promise.all(
          allClasses.map((eventClass: any) => {
            return getFreeSlots({
              eventId: eventDetailsData.eventId,
              eventClassId: eventClass[1]?.classId,
            });
          }),
        );
        const capacities = results.map(result => result.data);

        const createAgeGroupCapacities = (classes: TClassesByAgeGroupUI[]) => {
          const ageGroupCapacities: AgeGroupCapacitiesType = {};
          classes.forEach((eventClass: any, index: number) => {
            ageGroupCapacities[eventClass[1].classId] = {
              ageGroup: eventClass[0],
              full: !capacities[index],
              classId: eventClass[1].classId,
            };
          });

          return ageGroupCapacities;
        };

        const englishAgeGroupCapacities =
          createAgeGroupCapacities(englishClasses);
        const spanicehAgeGroupCapacities =
          createAgeGroupCapacities(spanishClasses);

        setEnglishGroupCapacities(englishAgeGroupCapacities);
        setSpanishGroupCapacities(spanicehAgeGroupCapacities);
      };

      fetchData();
    }
  }, [eventDetailsData, eventDetails]);

  return (
    <RegistrationContentBody>
      <LeftRegistrationContentWrapper>
        <Image alt="Registration Modal Art" src={RegistrationModalArt} />
      </LeftRegistrationContentWrapper>
      <RightRegistrationContentWrapper>
        {stepper === 0 && (
          <ChooseLanguage data={eventDetailsData as TRegistrationFormDataUI} />
        )}
        {stepper === 1 && (
          <EventInformation
            data={eventDetailsData as TRegistrationFormDataUI}
          />
        )}
        {stepper === 2 && <AdultInformation />}
        {stepper === 3 && (
          <ProvidingChildCare
            data={eventDetailsData as TRegistrationFormDataUI}
          />
        )}
      </RightRegistrationContentWrapper>
    </RegistrationContentBody>
  );
};
export default RegistrationContent;
